<template>
  <div>
    <v-container grid-md>
      <v-layout style="display: flex; flex-wrap: wrap">
        <v-flex d-flex class="login-box">
          <v-alert
            :value="true"
            v-if="error != null"
            type="error"
            v-html="error.message"
          ></v-alert>
          <v-alert :value="true" v-if="success != null" type="success">{{
            success.message
          }}</v-alert>
          <main v-if="loggedIn === false">
            <PageIntro
              :heading="'Parter platform logout'"
              :body="
                '<p>The partner platform is logging you out of ' +
                configStrings.clubName +
                ' ' +
                configStrings.productName +
                '.</p>'
              "
            />
          </main>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PageIntro from "@/components/PageIntro";
import qs from "qs";

export default {
  components: {
    PageIntro,
  },
  data() {
    return {
      error: null,
      loggedIn: false, //assume they are logged in
      valid: true,
      paramsValid: true,
      loading: false,
      success: null,
      qsParams: {},
      cookieName: "",
    };
  },
  mounted() {
    this.qsParams = qs.parse(window.location.search.substring(1));
    //console.log("qs", this.qsParams);

    if (
      !this.qsParams["id_token_hint"] ||
      !this.qsParams["post_logout_redirect_uri"]
    ) {
      this.paramsValid = false;
      this.error = { message: "Incorrect parameters specified" };
    } else {
      var oauthRedirectUri = this.qsParams["post_logout_redirect_uri"];
      try {
        this.$verifyToken(this.qsParams["id_token_hint"]).subscribe(
          data => {
            localStorage.removeItem("oauthClientId");
            localStorage.removeItem("oauthClientSecret");
            localStorage.removeItem("oauthResponseType");
            localStorage.removeItem("oauthRedirectUri");
            localStorage.removeItem("oauthScope");
            localStorage.removeItem("oauthState");
            localStorage.removeItem("oauthNonce");
            localStorage.removeItem("loginFlow");

            if (this.qsParams["state"]) {
              oauthRedirectUri += "?state=" + this.qsParams["state"];
            }
            window.location.replace(oauthRedirectUri);
          },
          error => {
            console.log('Error in verify likely token expired', error)
            localStorage.removeItem("oauthClientId");
            localStorage.removeItem("oauthClientSecret");
            localStorage.removeItem("oauthResponseType");
            localStorage.removeItem("oauthRedirectUri");
            localStorage.removeItem("oauthScope");
            localStorage.removeItem("oauthState");
            localStorage.removeItem("oauthNonce");
            localStorage.removeItem("loginFlow");
            if (this.qsParams["state"]) {
              oauthRedirectUri += "?state=" + this.qsParams["state"];
            }
            window.location.replace(oauthRedirectUri);

          }
        );
      } catch (error) {
        this.error = { message: "Invalid token passed" };
        console.error("JWT Error", error);
      }
    }

    console.log("valid?", this.paramsValid);
  },
  methods: {
    logout(e) {
      e.preventDefault();

      return true;
    },
  },
};
</script>